import {
  FeatureName,
  PermissionValues as Permissions,
} from '@gripp/shared-logic';
import { ImpersonationUserColumn } from '../impersonation/components/impersonationUserColumn';
import { ImpersonationWorkspaceColumn } from '../impersonation/components/impersonationWorkspaceColumn';
import { ImpersonationWorkspaceFiltersColumn } from '../impersonation/components/impersonationWorkspaceFiltersColumn';
import { SettingsApiKey } from './components/components/settingsApiKey';
import { SettingsAppearance } from './components/components/settingsAppearance';
import { SettingsCommunication } from './components/components/settingsCommunication';
import { SettingsPreferences } from './components/components/settingsPreferences';
import { SettingsProfile } from './components/components/settingsProfile';
import { Settings } from './components/settings';
import { IntegrationCallback } from './components/components/integrationCallback';
import { INTEGRATION_CALLBACK_PATH } from '../shared/logging/integrationCallbackPrivacy';
import { SettingsIntegrations } from './components/components/settingsIntegrations';
import { INTEGRATION_SETTINGS_PERMISSION } from './components/components/useIntegrationSettingsAccess';

export const settingsPaths = {
  root: 'settings',
};

// This return cannot use ProtectedRoute's active-workspace gates or persisted
// login destination. Its server mutation authorizes the captured workspace.
export const integrationCallbackRoute = {
  path: INTEGRATION_CALLBACK_PATH,
  element: <IntegrationCallback />,
};

export const settingsRoutes = [
  {
    path: settingsPaths.root,
    element: <Settings />,
    handle: {
      header: {
        titleKey: 'Settings',
        icon: 'cog-outline',
      },
    },
    children: [
      {
        path: 'profile',
        element: <SettingsProfile />,
      },
      {
        path: 'notifications',
        element: <SettingsPreferences />,
      },
      {
        path: 'appearance',
        element: <SettingsAppearance />,
        handle: {
          requiredFeature: FeatureName.Appearance,
        },
      },
      {
        path: 'api',
        element: <SettingsApiKey />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
      {
        path: 'integrations',
        element: <SettingsIntegrations />,
        handle: {
          requiredPermission: INTEGRATION_SETTINGS_PERMISSION,
          requiredFeature: FeatureName.IntegrationConnections,
        },
      },
      {
        path: 'communication',
        element: <SettingsCommunication />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
          requiredFeature: FeatureName.CommunicationPlatform,
        },
      },
      {
        path: 'impersonation/workspace',
        element: <ImpersonationWorkspaceColumn />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
      {
        path: 'impersonation/workspace/filters',
        element: <ImpersonationWorkspaceFiltersColumn />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
      {
        path: 'impersonation/user',
        element: <ImpersonationUserColumn />,
        handle: {
          requiredPermission: Permissions.globalAdmin,
        },
      },
    ],
  },
];
